// extracted by mini-css-extract-plugin
export default {"container":"ErrorBoundary_container__+Vey2","title":"ErrorBoundary_title__swFJF","message":"ErrorBoundary_message__B+WB0","button":"ErrorBoundary_button__Z716G"};